import React, { type ComponentProps, type FC } from 'react';
import classnames from 'classnames';

import LegacyPrices from 'pages/Product/components/Prices';

import styles from 'theme/pages/wise/WiseProduct/components/WisePrices/WisePrices.module.scss';

import WisePricesProductOptions from './WisePricesProductOptions';

export type WisePricesProps = ComponentProps<typeof LegacyPrices>;

const WisePrices: FC<WisePricesProps> = (props) => (
  <div
    className={classnames(
      styles.wisePricesRoot,
      'StylePath-Pages-Wise-WiseProduct-components-WisePrices'
    )}>
    <LegacyPrices
      {...props}
      compactProductPricesLayout
      wisePricesMainContentClassName="wise-prices-pdp-main"
      wisePricesPriceSummaryClassName={styles.wisePricesPriceSummary}
      renderProductPriceOptions={({ prices, unitId, onSelectUnit }) => (
        <WisePricesProductOptions prices={prices} unitId={unitId} onSelectUnit={onSelectUnit} />
      )}
    />
  </div>
);

export default WisePrices;
